import { render, staticRenderFns } from "./AnLollipop.vue?vue&type=template&id=448e8c97&scoped=true&"
import script from "./AnLollipop.vue?vue&type=script&lang=js&"
export * from "./AnLollipop.vue?vue&type=script&lang=js&"
import style0 from "./AnLollipop.vue?vue&type=style&index=0&id=448e8c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e8c97",
  null
  
)

export default component.exports